exports.getBuildEnvironment = function () {
  return process.env.GATSBY_BUILD_ENV;
};

exports.getIsProd = function () {
  return process.env.NODE_ENV === 'production';
};

exports.getApiUrl = function () {
  return process.env.GATSBY_API_URL || '';
};

exports.getAssetUrl = function () {
  return process.env.GATSBY_STATIC_URL || '';
};

exports.getLang = function () {
  if (
    process.env.GATSBY_LANG === 'uk' ||
    process.env.GATSBY_LANG === 'kz' ||
    process.env.GATSBY_LANG === 'pl'
  ) {
    return 'en';
  }
  return process.env.GATSBY_LANG;
};
